import React from "react";

function Footer() {
  return (
    <div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="logo">
                <div className="logo-wrapper logo-designn">MAC PRINCE</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="text">
                <p>© 2025 Mac Prince. All Rights Reserved.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="social-icon">
                <ul>
                  <li>
                    <a href="https://x.com/MacPrinceDev">
                      <i className="flaticon-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/share/1APXYwVpYd/?mibextid=wwXIfr">
                      <i className="flaticon-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/macprince_thedev/">
                      <i className="flaticon-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/in/princewill-nkemjika">
                      <i className="flaticon-linkedin" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
